export default "__VITE_ASSET__Dv$LMgfR__"